import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "../components/Layout/Layout";
import DashboardLayout from "./components/DashboardLayout";
import Loader from "../pages/Loader";
import "./css/Orders.css";
import { apiClient } from "../config/api.client";

const Orders = () => {
	const navigate = useNavigate();
	const { user } = useSelector((state) => state.user);
	const [allOrders, setAllOrders] = useState([]);
	const [loading, setLoading] = useState(false);

	const getAllUserOrders = async () => {
		try {
			setLoading(true);
			const endDate = new Date();
			const startDate = new Date();
			startDate.setDate(endDate.getDate() - 30); // Get last 30 days

			const res = await apiClient.get("/order/history", {
				params: {
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
					page: 1,
					limit: 50,
				},
			});
			if (res.data?.success) {
				const mapped = (res.data.orders || []).map((o) => {
					let parsedDesc = null;
					try {
						parsedDesc = o?.description ? JSON.parse(o.description) : null;
					} catch (e) {
						parsedDesc = null;
					}
					const firstItem = Array.isArray(o?.items) && o.items.length > 0 ? o.items[0] : null;
					return {
						orderId: o?.orderId,
						p_info: firstItem?.itemName || "Product",
						price: firstItem?.price ?? o?.amount,
						userId: parsedDesc?.playerId || "",
						zoneId: parsedDesc?.server || "",
						paymentMode: o?.paymentMethod,
						status: o?.status,
						createdAt: o?.createdAt,
						amount: o?.amount,
					};
				});
				setAllOrders(mapped.reverse());
				setLoading(false);
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			console.log(error);
		}
	};

	useEffect(() => {
		if (user !== null) {
			getAllUserOrders();
		}
	}, [user]);

	function getOrderStatus(value) {
		switch (value) {
			case "pending":
				return "text-warning";
			case "failed":
				return "text-danger";
			case "cancelled":
				return "text-danger";
			case "processing":
				return "text-primary";
			case "success":
				return "text-success";
			case "refunded":
				return "text-primary";
			default:
				return "text-dark";
		}
	}

	return (
		<Layout>
			<DashboardLayout>
				<div className="user-order-container">
					{allOrders.length === 0 ? (
						<div className="no-order-found">
							<b>No Order Found</b>
							<button
								className="btn text-decoration-underline"
								onClick={() => navigate("/games")}
							>
								Go to Shop
							</button>
						</div>
					) : (
						<>
							<table className="w-100 table d-none d-md-table d-lg-table">
								<thead>
									<tr>
										<th>Order ID</th>
										<th>Date</th>
										<th>Status</th>
										<th>Total</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									{allOrders?.map((item, index) => {
										return (
											<tr key={index}>
												<td>{item?.orderId}</td>
												<td>
													{item?.createdAt
														? new Date(item.createdAt).toLocaleDateString(
															"default",
															{
																year: "numeric",
																month: "long",
																day: "numeric",
																hour: "numeric",
																minute: "numeric",
																second: "numeric",
															}
														)
														: ""}
												</td>
												<td>{item?.status}</td>
												<td>{item?.price}</td>
												<td>
													<button
														onClick={() =>
															navigate(`/view-order/${item?.orderId}`)
														}
														className="view-btn"
													>
														View
													</button>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
							<div className="orderhistory d-block d-md-block d-lg-none">
								<p>Order History</p>
								{allOrders &&
									allOrders.map((item, index) => {
										return (
											<div className="history">
												<div className="item">
													<h4 className="m-0">{item?.p_info}</h4>
													<b>
														<span>₹{item?.price}</span>
													</b>
												</div>
												<div className="item">
													<span className="text-muted">
														<small>{item?.orderId}</small>
													</span>
													<span className="text-dark">
														<small>
															{item?.userId} {item?.zoneId && item?.zoneId}
														</small>
													</span>
												</div>
												<div className="item">
													<span className="text-muted">
														<small>{item?.amount}</small>
													</span>
													<span className="text-primary">
														<small>Paid using {item?.paymentMode}</small>
													</span>
												</div>
												<div className="item">
													<span className="text-success">
														<small>
															{new Date(item?.createdAt).toLocaleString(
																"default",
																{
																	day: "numeric",
																	month: "numeric",
																	year: "numeric",
																	hour: "numeric",
																	minute: "numeric",
																	second: "numeric",
																}
															)}
														</small>
													</span>
													<span className={`${getOrderStatus(item?.status)}`}>
														{item?.status}
													</span>
												</div>
											</div>
										);
									})}
							</div>
						</>
					)}
				</div>
			</DashboardLayout>
		</Layout>
	);
};

export default Orders;
